import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateCategorizerService {

  constructor() { }

  categorizeDate(timestamp: string): string {
    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const startOfThisWeek = new Date(today);
    startOfThisWeek.setDate(today.getDate() - today.getDay());

    const startOfThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Day 0 of current month is the last day of previous month
    const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
    const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);

    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    }
    if (date.toDateString() === yesterday.toDateString()) {
      return 'Earlier this week';
    }
    if (date >= startOfThisWeek && date < today) {
      return 'Earlier this week';
    }

    if (date >= startOfThisMonth && date < startOfThisWeek) {
      return 'Earlier this month';
    }

    // if (date >= startOfLastMonth && date <= endOfLastMonth) {
    //   return 'Earlier this month';
    // }
    if (date >= startOfThisMonth && date < today) {
      return date.toLocaleString('default', { month: 'long' });
    }
    if (date.getFullYear() === today.getFullYear()) {
      return date.toLocaleString('default', { month: 'long' });
    }
    if (date >= startOfLastYear && date <= endOfLastYear) {
      return `${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
    } else {
      return date.getFullYear().toString();
    }
  }

  groupChatsByType(chats: any[]): any[] {
    const groupedData: { [key: string]: any[] } = {};

    chats.forEach((chat: any) => {
      const category = this.categorizeDate(chat.timestamp);
      if (!groupedData[category]) {
        groupedData[category] = [];
      }
      groupedData[category].push(chat);
    });

    return Object.keys(groupedData).map(type => ({
      type,
      data: groupedData[type]
    }));
  }

  sortGroupedDataByType(groupedData: any[]): any[] {
    const today = new Date();
    const staticTypeOrder = ['Today', 'Earlier this week', 'Earlier this month'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

     groupedData.sort((a, b) => {
      const aIndex = staticTypeOrder.indexOf(a.type);
      const bIndex = staticTypeOrder.indexOf(b.type);

      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      const isYearMonth = (type: string) => /^[a-zA-Z]+ \d{4}$/.test(type);
      const isYear = (type: string) => /^\d{4}$/.test(type);
      const isMonth = (type: string) => /^[a-zA-Z]+$/.test(type);

      if (isYearMonth(a.type) && isYearMonth(b.type)) {
        const [aMonthStr, aYearStr] = a.type.split(' ');
        const [bMonthStr, bYearStr] = b.type.split(' ');
        const aYear = parseInt(aYearStr, 10);
        const bYear = parseInt(bYearStr, 10);
        if (aYear !== bYear) {
          return bYear - aYear;
        }
        const aMonthIndex = months.indexOf(aMonthStr);
        const bMonthIndex = months.indexOf(bMonthStr);
        return bMonthIndex - aMonthIndex;
      }

      if (isYearMonth(a.type)) return 1;
      if (isYearMonth(b.type)) return -1;

      if (isYear(a.type) && isYear(b.type)) {
        return parseInt(b.type) - parseInt(a.type);
      }
      if (isYear(a.type)) return 1;
      if (isYear(b.type)) return -1;

      if (isMonth(a.type) && isMonth(b.type)) {
        const aMonthIndex = months.indexOf(a.type);
        const bMonthIndex = months.indexOf(b.type);
        return bMonthIndex - aMonthIndex;
      }

      const dateA = a.data[0]?.timestamp ? new Date(a.data[0].timestamp) : new Date(0);
      const dateB = b.data[0]?.timestamp ? new Date(b.data[0].timestamp) : new Date(0);
      return dateB.getTime() - dateA.getTime();
    });

    // Sort the data within each group by timestamp in descending order
    groupedData.forEach(group => {
      group.data.sort((a:any, b:any) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
    });
    return groupedData;   
  }
}